import React from 'react';

import { STATIC_ROOT } from '../../constants';

export const Logo = ({ className }) => (
    <img src={`${STATIC_ROOT}/logo.png`} alt="logo" width="153" height="37" />
);



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js